// Super Master > Migração (pedido 2026-09-30) — empresa → cliente → linhas
// dos rastreadores, envio de comando por SMS (saldo da empresa) e status
// online/offline ao vivo. Backend: src/platform-migration/ (platformAuthGuard).
import { platformGet, platformPost } from "@/lib/api/gpsdrive-platform-client";

export interface MigrationClient {
  traccarUserId: number;
  name: string;
  email: string;
}

export interface MigrationDevice {
  id: number;
  name: string;
  imei: string;
  line: string | null;
  carrier: string | null;
  trackerModel: string | null;
  protocol: string | null;
  status: "online" | "offline" | "unknown";
  lastUpdate: string | null;
}

export interface MigrationCommand {
  id: string;
  name: string;
  text: string;
  protocol: string;
}

export interface MigrationContext {
  sms: { enabled: boolean; balance: number };
  commands: MigrationCommand[];
}

const base = "/api/v1/platform-migration/companies";

export const gpsDrivePlatformMigrationService = {
  clients: (companyId: string) => platformGet<MigrationClient[]>(`${base}/${companyId}/clients`),
  devices: (companyId: string, traccarUserId: number) =>
    platformGet<MigrationDevice[]>(`${base}/${companyId}/clients/${traccarUserId}/devices`),
  context: (companyId: string) => platformGet<MigrationContext>(`${base}/${companyId}/context`),
  send: (companyId: string, deviceId: number, text: string) =>
    platformPost<{ sent: true; balanceAfter: number }>(`${base}/${companyId}/send`, { deviceId, text }),
};
